'use strict'
import { initializeApp } from 'firebase/app'
import { getAuth } from 'firebase/auth'
import { firebaseConfig } from './config.js'

// Initialize Firebase app (singleton)
const app = initializeApp(firebaseConfig)
const auth = getAuth(app)

export { app, auth }
